import React from 'react';

import useHeaderTitle from '../hooks/useHeaderTitle';

const HeaderTitle = ({ title, quotationsMethod }) => {

    const { hasTitle } = useHeaderTitle(title);

    if (!hasTitle()) return null;

    return (
        <div className='slc-header-title slc-font-title'>{ title }</div>
    );

};

export default HeaderTitle;